module.exports = __webpack_public_path__ + "static/media/buy_start_service_rent_1.84a89a94.jpg";